import { render } from "./Nobankdocs.vue?vue&type=template&id=f2abd620&scoped=true"
import script from "./Nobankdocs.vue?vue&type=script&lang=js"
export * from "./Nobankdocs.vue?vue&type=script&lang=js"

import "./Nobankdocs.vue?vue&type=style&index=0&id=f2abd620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2abd620"]])

export default __exports__